import React from 'react';
import PageBanner from '../../components/PageBanner';
import { productionRouteBanners, productionRouteBannerAlts } from '../../constants/sectionBanners';
import './SpecialEffects.css';

const SpecialEffects = () => {
  const entryConcepts = [
    'Silver Deer Entry',
    'Roman Buggy',
    'Royal Buggy',
    'Grand Buggy',
    'Cinderella Open Buggy',
    'Cinderella Entry',
    'Bahubali Entry',
    'Sinhasan Entry',
    'Heart Shape Entry',
    'Rajvadi Auto',
    'White Tricycle Entry',
    'Pink Tricycle Entry',
    'Love Bird Cycle',
    'Scooter & Sidecar',
    '3 Wheel Bike',
    'Vintage Car',
    'Ring Ceremony',
    'Golden Doli Entry',
    'Blue Queen Doli',
    'Peacock Doli',
    'Bridal Dome Entry',
    'Flower Doli',
    'Jodha Theme',
    'Padmavati Theme',
    'Flower Chadaar',
    'Rajvadi Umbrella',
    'Revolving Stage',
    'Smoke Pot Entry',
    'Balloon Blast Effect',
  ];

  const specialEffects = [
    'Pyrotechnics',
    'Fire Work',
    'Confetti Blast',
    'Co2 Effect',
    'Smoke Effect',
    'Bubble Effect',
    'Foam Effect',
    'Flower Shower',
    'Rain Setup',
    'Artificial Snow',
    'Walkie Talkie',
    'Fire Safety',
  ];

  return (
    <div className="special-effects-page">
      <PageBanner
        title="Special Effects"
        image={productionRouteBanners['special-effects']}
        imageAlt={productionRouteBannerAlts['special-effects']}
      />
      
      <section className="section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">About Special Entry Concept</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Make a grand entrance with our unique entry concepts
            </p>
          </div>

          <div className="entry-concepts">
            <div className="concepts-grid">
              {entryConcepts.map((concept, index) => (
                <div key={index} className="concept-card">
                  <span>{concept}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="effects-section">
            <h2 className="section-title">Special Effects for Events</h2>
            <div className="effects-grid">
              {specialEffects.map((effect, index) => (
                <div key={index} className="effect-card">
                  <span>{effect}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SpecialEffects;
